import css from '@styled-system/css';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { AvatarList } from '../Avatar';
import { FormattedDate } from '../FormattedDate';
import { Box, Flex } from '../Layout';
import { SecondaryText } from '../Typography';
export const Card = styled(Box).withConfig({
  displayName: "Card",
  componentId: "sc-1gnzppj-0"
})(_ref => {
  let {
    cursor,
    borderColor,
    borderRadius,
    overflow
  } = _ref;
  return css({
    border: "4px solid ".concat(borderColor),
    cursor: cursor !== null && cursor !== void 0 ? cursor : 'pointer',
    borderRadius: typeof borderRadius !== 'undefined' ? borderRadius : 3,
    boxShadow: 6,
    backgroundColor: 'background.pureWhite',
    overflow: overflow || 'initial'
  });
});
const mediaBorderStyles = {
  top: 'border-top-right-radius: 12px; border-top-left-radius: 12px;',
  left: 'border-bottom-left-radius: 12px; border-top-left-radius: 12px;',
  right: 'border-top-right-radius: 12px; border-bottom-right-radius: 12px;'
};
Card.Media = styled(Box).withConfig({
  displayName: "Media",
  componentId: "sc-1gnzppj-1"
})(["&&&{position:relative;img{display:block;width:100%;max-width:100%;", "}}"], props => mediaBorderStyles[props.layout]);
Card.Media.defaultProps = {
  layout: 'top'
};
Card.Actions = styled(Flex).withConfig({
  displayName: "Actions",
  componentId: "sc-1gnzppj-2"
})(["position:absolute;bottom:0;right:0;margin-right:6px;justify-content:flex-end;transform:translateY(50%);"]);
Card.Date = FormattedDate;
Card.Content = styled(Box).withConfig({
  displayName: "Content",
  componentId: "sc-1gnzppj-3"
})(css({
  padding: 2
}));
Card.Assistants = React.memo(function CardAssistants(_ref2) {
  let {
    assistants,
    totalAssistants,
    i18n
  } = _ref2;
  const assistantsLabel = useMemo(() => {
    if (!assistants) return '';
    let label = assistants.slice(0, 1).map(el => el.firstName).join(', ');
    if (totalAssistants > 1) label += " & ".concat(totalAssistants - 1, " ").concat(i18n.assistantsMulti);else label += "".concat(i18n.assistantsSimple);
    return label;
  }, [assistants, totalAssistants]);
  return React.createElement(Flex, {
    alignItems: "center",
    marginY: 1
  }, React.createElement(AvatarList, {
    data: assistants,
    size: "micro",
    marginRight: 2
  }), React.createElement(SecondaryText, {
    wrapped: true
  }, assistantsLabel));
});
Card.Assistants.propTypes = {
  assistants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    imageUrl: PropTypes.string
  })),
  totalAssistants: PropTypes.number,
  i18n: PropTypes.shape({
    assistantsMulti: PropTypes.string,
    assistantsSimple: PropTypes.string
  })
};
Card.Assistants.defaultProps = {
  assistants: null,
  totalAssistants: 0,
  i18n: {}
};